// @ts-strict-ignore
import {Component} from 'panel';

import {Visibility} from 'common/components/base/stackable';
import {promisifyModal} from 'common/components/modal/utils';
import {emitTrackEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {getLocation} from 'common/util/url';

import {template} from './template';
import css from './index.inline.styl';

export class FYTModal extends Component<EmptyObj> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.track(`Viewed FYT modal`);
  }

  track(eventName: string): void {
    emitTrackEvent(this, {
      eventName,
    });
  }

  handleEditDiscoverabilityButtonClicked = () => {
    this.track(`Clicked edit discoverability on FYT modal`);
    getLocation().href = `/settings/org/find-your-org`;
  };

  handleFYTModalStateChanged = (ev) => {
    if (ev?.detail?.state === Visibility.Closed) {
      this.track(`Closed FYT modal`);
    }
  };
}

export async function promptFYTModal(): Promise<boolean> {
  const closeEv = await promisifyModal({
    tagName: `mp-find-your-team-modal`,
    attrs: {},
    closeEvents: [`close`],
  });

  return closeEv.detail.submitted;
}

export const FYTModalEl = defineAndMakeJsxFactory<EmptyObj>(`mp-find-your-team-modal`, FYTModal);
export const FYTModalReact = panel2react<EmptyObj>(`mp-find-your-team-modal`, FYTModal);
